import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUniqueVoucher } from '@/shared/model/unique-voucher.model';

const baseApiUrl = 'api/unique-vouchers';
const baseSearchApiUrl = 'api/_search/unique-vouchers?query=';

export default class UniqueVoucherService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUniqueVoucher> {
    return new Promise<IUniqueVoucher>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUniqueVoucher): Promise<IUniqueVoucher> {
    return new Promise<IUniqueVoucher>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUniqueVoucher): Promise<IUniqueVoucher> {
    return new Promise<IUniqueVoucher>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
